<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-confirm-delivery-address"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="text-title">{{lbl.confirm_delivery_address.title}}</div>
                    <div class="text-sub-title">{{lbl.confirm_delivery_address.sub_title}}</div>
                    <div class="content-wrapper" v-if="address">
                        <img v-if="address.isSaveAddress" src="@/assets/icon/delivery/ic-home.svg" alt="">
                        <div class="name-text">{{ address.firstName }} {{ address.lastName }}</div>
                        <div class="number-text">{{ address.contactNumber | phone_format }}</div>
                        <div class="address-text">
                            {{ addressDetail() }}
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <Button class="btn-confirm"
                        customStyle="confirm-btn-wrapper"
                        btnId="confirm_redeem_btn"
                        :btnMsg="lbl.default.confirm"
                        @clickButton="clickOk()" />
                    <Button class="btn-cancel"
                        customStyle="confirm-btn-wrapper"
                        btnId="cancel_redeem_btn"
                        :btnMsg="lbl.confirm_delivery_address.change_address"
                        @clickButton="clickCacnel()" />
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//helper
import Locale from '@/helper/locale/locale.js';
import CacheHelper from "@/helper/CacheHelper.js";
// component
// import TwoButtonRow from '../../../Button/TwoButtonRow.vue'
import Button from '../../../Button/Button.vue';

export default {
    name: 'FreeDeliverySuccessModal',
    props: {
        controller: Object,
        modalId: String
    },
    components: {
        Button
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            tag: null,
            address: null,

            busModal: null,
            cache: new CacheHelper('session'),
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickOk: function(){
            this.hide();
            this.controller.eventClickConfirm({ tag: this.tag });
        },
        clickCacnel: function(){
            this.hide();
            this.controller.eventClickCancel({ tag: this.tag });
        },
        close: function () {
            if(this.cache.getCache('isFromBDM')){
                this.cache.removeCache('isFromBDM');
                this.$router.push('/');
            }else{
                this.$router.back();
            }

            this.hide();
        },
        show: function (config) {
            this.tag = config.tag;
            this.address = config.address;

            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
        addressDetail: function () {
            if (this.address == null) return;
            return this.address.address + ' ' + this.address.subDistrictName + ', ' + this.address.districtName + ', ' + this.address.provinceName + ', ' + this.address.zipcode;
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/input/BaseButton.scss';
.modal-confirm-delivery-address {
    .modal-body{
        .modal-base-head{
            .icon-check{
                padding: 40px 0 20px;
                img{
                    width: 62px;
                }
            }
            .icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                img{
                    width: 18px;
                }
            }
        }

        .modal-base-body{
            @include mini-mobile(){
                font-size: 1.1rem;
            }

            .text-title{
                font-family: $medium;
                color: $bright-gray; 
                font-size: 20px;
                text-align: center;
            }
            .text-sub-title{
                font-family: $regular;
                color: $bright-gray; 
                font-size: 20px;
                text-align: center;
            }
            .content-wrapper {
                margin: 24px 0px;
                border-radius: 20px;
                background-color: $bg-color;
                padding: 16px 20px;
                .name-text {
                    font-family: $semiBold;
                    font-size: 20px;
                    color: $dark-blue;
                }
                .number-text {
                    font-family: $regular;
                    font-size: 14px;
                    color: $border-gray;
                }
                .address-text {
                    font-family: $regular;
                    font-size: 16px;
                    color: $blue-gray;
                    padding-top: 4px;
                }
            }
        }

        .modal-base-footer {
            display: grid;
            grid-template-columns: 1fr;
            gap: 10px;
            .btn-cancel {
                width: 100%
            }
            .btn-confirm {
                width: 100%
            }
        }

        .btn-view-reward{
            @include btn-wrapper();
            width: 100%;
            margin: 0 auto 30px;

            background-color: $white;
            border: 2px solid $blue-gray;
            .btn-txt{
                color: $blue-gray;
            }
        }
    }
}
</style>
<style lang="scss">
.modal-confirm-delivery-address{
    .modal-body{
        padding: 24px;
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        margin: auto;
    }

    .modal-content{
        border: none;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

}
</style>
